import { render, staticRenderFns } from "./_TenantForm.vue?vue&type=template&id=3752a6a2&scoped=true&"
import script from "./_TenantForm.vue?vue&type=script&lang=js&"
export * from "./_TenantForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3752a6a2",
  null
  
)

export default component.exports